import { createContext, useContext, useState, useCallback } from "react";
import { DICT } from "@/i18n/dict";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("olime_lang") || "fr");
  const setLang = useCallback((l) => {
    localStorage.setItem("olime_lang", l);
    setLangState(l);
  }, []);
  const c = DICT[lang] || DICT.fr;
  return <LangCtx.Provider value={{ lang, setLang, c }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
